import * as Types from '../actions/Types'

const INITIAL_STATE = {
  isCreating: false,
  errorCreating: null,
  isDeletingPost: [],
  errorDeletingPost: null
}

export default (state = INITIAL_STATE, action) => {
  const { payload, type } = action

  switch (type) {
    case Types.CREATE_POST:
      return {
        ...state,
        isCreating: true,
        errorCreating: null
      }
    case Types.CREATE_POST_SUCCESS:
      return {
        ...state,
        isCreating: false,
        errorCreating: null
      }
    case Types.CREATE_POST_FAILED:
      return {
        ...state,
        isCreating: false,
        errorCreating: payload
      }
    case Types.DELETE_POST:
      return {
        ...state,
        isDeletingPost: [payload, ...state.isDeletingPost],
        errorDeletingPost: null
      }
    case Types.DELETE_POST_SUCCESS:
      return {
        ...state,
        isDeletingPost: state.isDeletingPost.filter(id => id !== payload),
        errorDeletingPost: null
      }
    case Types.DELETE_POST_FAILED:
      return {
        ...state,
        isDeletingPost: state.isDeletingPost.filter(id => id !== payload),
        errorDeletingPost: payload
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/components/reducers/NewsFeed.js